import {Box, Grid, gridRepeat, gridTracks} from 'platform/foundation';
import styled from 'styled-components';

import {prop, range, xprod} from 'ramda';

import {DashboardTileSize} from '../../../types/DashboardTileSize';
import {DASHBOARD_GRID_COLUMNS} from '../../../utils/allocateDashboardGrid';
import {DASHBOARD_TILE_SIZES} from '../../../utils/dashboardTileSizes';

interface DashboardTileSizeShapeProps {
  size: DashboardTileSize;
}

const SHAPE_WIDTH = 10;
const SHAPE_HEIGHT = 5;
const SHAPE_GAP = 1;
// The tallest tile spans two rows, so two rows show every size.
const SHAPE_ROWS = 2;
const FIRST_CELL = 1;

const SHAPE_CELLS = xprod(
  range(FIRST_CELL, SHAPE_ROWS + FIRST_CELL),
  range(FIRST_CELL, DASHBOARD_GRID_COLUMNS + FIRST_CELL)
).map(([row, column]) => ({column, row}));

const SHAPE_ROW_TRACKS = gridTracks(gridRepeat(SHAPE_ROWS, '1fr'));

const StyledShapeCell = styled.div<{$isFilled: boolean}>`
  border-radius: ${({theme}) => theme.radii.xSmall};
  background: ${({theme, $isFilled}) =>
    $isFilled ? theme.colors.palettes.blue[80][100] : theme.colors.palettes.neutral[70][40]};
`;

export function DashboardTileSizeShape(props: DashboardTileSizeShapeProps) {
  const {columns, rows} = prop(props.size, DASHBOARD_TILE_SIZES);

  return (
    // Plain div: the shape is decorative, and `Box` does not forward `aria-hidden`.
    <div aria-hidden>
      <Box width={SHAPE_WIDTH} height={SHAPE_HEIGHT}>
        <Grid
          columns={DASHBOARD_GRID_COLUMNS}
          rows={SHAPE_ROW_TRACKS}
          spacing={SHAPE_GAP}
          height="100%"
        >
          {SHAPE_CELLS.map((cell) => (
            <StyledShapeCell
              key={`${cell.column}x${cell.row}`}
              $isFilled={cell.column <= columns && cell.row <= rows}
            />
          ))}
        </Grid>
      </Box>
    </div>
  );
}
